var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},[_c('v-select',{ref:"encoding",attrs:{"value":_vm.value,"rules":_vm.rules.encoding,"items":_vm.encodingTypes,"label":_vm.label,"disabled":_vm.disabled,"data-cy":"encoding-select"},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }